import { cookie } from './lister-utilities';

export const checkBasket = () => {
	const basketCookie = cookie('BasketSimple').get();

	if (basketCookie) {
		const productsInBasket = JSON.parse(decodeURIComponent(basketCookie));

		const Products = productsInBasket?.Products?.map((item) => item.Sku);

		return {
			list: Products,
			number: Products.length,
		};
	}

	return null;
};
